import type { ComponentChildren } from 'preact';
import { useEffect } from 'preact/hooks';
import { useI18n } from '../i18n';
import { useAuth } from '../lib/auth';

/// Gate for /partner — admin OR partner role passes through. Admins keep
/// access so they can preview the self-service page on behalf of a partner
/// account. Redirects to login when signed out; shows a friendly "not
/// authorised" panel for plain users.
export function RequirePartner({ children }: { children: ComponentChildren }) {
  const { status, user } = useAuth();
  const { localePath } = useI18n();

  useEffect(() => {
    if (status === 'signed-out') {
      location.replace(localePath('/partner/login'));
    }
  }, [status]);

  if (status === 'unknown') {
    return (
      <div class="admin-page">
        <div class="admin-shell">
          <p class="admin-lede">Checking session…</p>
        </div>
      </div>
    );
  }
  if (status === 'signed-out') {
    return null;
  }
  if (user?.role !== 'partner' && user?.role !== 'admin') {
    return (
      <div class="admin-page">
        <div class="admin-shell">
          <h1>Not authorised</h1>
          <p class="admin-lede">
            This area is for BeerCup partners. You're signed in as
            <strong> {user?.email}</strong> but your role is <strong>{user?.role}</strong>.
            Ask an admin to link your account to a partner.
          </p>
          <a class="admin-back" href={localePath()}>← BeerCup</a>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
